const BASE = 'alert :';

export const alertActionTypes = {
  openAlert: `${BASE} open`,
  closeAlert: `${BASE} close`,
};

/**
 *
 * @param {object} props
 * @param {any} props.message
 * @param {any} props.variant
 * @param {any} [props.action]
 * @param {number} [props.time]
 * @param {'top'|'bottom'} [props.vertical] - defaults to 'bottom'
 * @param {'left'|'right'} [props.horizontal] - defaults to 'left
 */
export const openAlert = ({
  message,
  variant,
  action,
  time = 4000,
  vertical = 'bottom',
  horizontal = 'left',
}) => ({
  type: alertActionTypes.openAlert,
  message,
  action,
  variant,
  vertical,
  horizontal,
  time,
});

export const closeAlert = (onClose) => ({
  type: alertActionTypes.closeAlert,
  onClose,
});
